import type { Issue } from "@productlane/zero"

// Its own children can't become its parent: Linear rejects the loop.
export function parentCandidates<
	T extends Pick<Issue, "id" | "parentLinearId">,
>(issue: Pick<Issue, "id" | "linearTicketId">, results: readonly T[]) {
	return results.filter(
		(candidate) =>
			candidate.id !== issue.id &&
			candidate.parentLinearId !== issue.linearTicketId,
	)
}
